import React, { useCallback } from "react";
import PropTypes from "prop-types";
import { Field } from "formik";
import FormControl from "@material-ui/core/FormControl";
import Checkbox from "@material-ui/core/Checkbox";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import FormFieldError from "components/form/form-field-error";
import { formikPropTypes } from "components/common";

export const SimpleCheckbox = ({
  name,
  value,
  onChange,
  onBlur,
  label,
  className,
  labelClassName,
  checked,
  ...props
}) => (
  <FormControl className={className} margin="normal" fullWidth>
    <FormControlLabel
      classes={{
        label: labelClassName,
      }}
      control={
        <Checkbox name={name} value={value} checked={checked || false} onChange={onChange} onBlur={onBlur} {...props} />
      }
      label={label}
    />
    <FormFieldError name={name} />
  </FormControl>
);

SimpleCheckbox.propTypes = {
  /**
   * Nombre del input
   */
  name: PropTypes.string,
  /**
   * Valor actual del componente
   */
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.bool, PropTypes.number, PropTypes.object]),
  /**
   * Callback que se dispara con el cambio del input
   */
  onChange: PropTypes.func,
  /**
   * Callback que se dispara con el cambio de foco
   */
  onBlur: PropTypes.func,
  /**
   * Clase adicional del componente.
   */
  className: PropTypes.string,
  /**
   * Etiqueta del input
   */
  label: PropTypes.node,
  /**
   * Valor checked del checkbox
   */
  checked: PropTypes.bool,
  /**
   * Id del input
   */
  id: PropTypes.string,
  /**
   * Inidica si el input está deshabilitado
   */
  disabled: PropTypes.bool,
};

const ValidatedCheckbox = ({ field: { name, value, onChange, onBlur }, ...props }) => (
  <SimpleCheckbox name={name} value={value} onChange={onChange} onBlur={onBlur} {...props} />
);

ValidatedCheckbox.propTypes = {
  ...formikPropTypes,
  ...SimpleCheckbox.propTypes,
};

const FormCheckbox = ({ name, onChange, value, onBlur, ...props }) => {
  const handleChange = useCallback((event, checked) => onChange(name)(checked), [name, onChange]);
  return (
    <Field
      component={ValidatedCheckbox}
      field={{
        name,
        onChange: handleChange,
        value,
        onBlur,
      }}
      {...props}
    />
  );
};

FormCheckbox.propTypes = {
  /**
   * Valor actual del componente
   */
  value: PropTypes.string,
  /**
   * Nombre del input
   */
  name: PropTypes.string,
  /**
   * Clase adicional del componente.
   */
  className: PropTypes.string,
  /**
   * Etiqueta del input
   */
  label: PropTypes.node,
  /**
   * Valor checked del checkbox
   */
  checked: PropTypes.bool,
  /**
   * Callback que se dispara con el cambio del input
   */
  onChange: PropTypes.func,
  /**
   * Callback que se dispara con el cambio de foco
   */
  onBlur: PropTypes.func,
  /**
   * Id del input
   */
  id: PropTypes.string,
  /**
   * Inidica si el input está deshabilitado
   */
  disabled: PropTypes.bool,
};

export default FormCheckbox;
